import {
  Button, Col, Row, Typography, Space, Form, Flex, Checkbox
} from "antd";
import { LeftCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { appRoutes } from "../../constants/routes";
import InvoiceDataForm from "../InvoiceDataForm";
import CurrentDoctor from "../CurrentDoctor";
import useBook from "./useBook";
import useCurrentUser from "../../hooks/useCurrentUser";

const { Text, Title } = Typography;

const Book = () => {
  const { t } = useTranslation();
  const { data } = useCurrentUser();
  const {
    handleSubmit,
    appointmentData,
    loading,
    navigate,
    form
  } = useBook();

  return (
    <Row gutter={20}>
      <Col span={24} xl={17}>
        <Button
          type="link"
          onClick={() => navigate(appRoutes.appointments, { replace: true })}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <Space size="small"><LeftCircleOutlined style={{ color: "#000000", opacity: "0.45" }} />
            <Text type="secondary">{t("global.button.goBack")}</Text>
          </Space>
        </Button>
        <Flex vertical style={{ marginBottom: 24 }}>
          <Title level={3}>{t("appointmentBookingPage.title")}</Title>
          <Text type="secondary" style={{ marginBottom: 16 }}>
            {t("appointmentBookingPage.subtitle")}
          </Text>
          <Title level={3} style={{ margin: 0 }}>
            {data.free_appointment
              ? (
                <span>
                  <s className="text-white">€ 59</s> € 0
                </span>
              )
              : "€ 59"}
          </Title>
        </Flex>
        <InvoiceDataForm form={form} handleSubmit={handleSubmit} />
        <Row gutter={24}>
          <Col span={24} sm={12}>
            <Form
              form={form}
              onFinish={handleSubmit}
            >
              <Form.Item
                name="tesseraSanitariaAuth"
                valuePropName="checked"
                rules={[{ required: true }]}
              >
                <Checkbox
                  style={{ lineHeight: 1.2 }}
                >
                  {t("appointmentBookingPage.checkbox")}
                </Checkbox>
              </Form.Item>
            </Form>
          </Col>
          <Col span={24} sm={12}>
            <Flex justify="end">
              <Button
                type="primary"
                size="large"
                disabled={loading || appointmentData}
                loading={loading || appointmentData}
                onClick={() => form.submit()}
              >
                {t("appointmentBookingPage.submitButton")}
              </Button>
            </Flex>
          </Col>
        </Row>
      </Col>
      <Col span={24} xl={7} style={{ paddingTop: 46 }}>
        <CurrentDoctor/>
      </Col>
    </Row>
  );
};

export default Book;
